<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />
    <v-progress-linear v-if="onProgress"
                       indeterminate
    ></v-progress-linear>
    <modal-agree></modal-agree>
    <dashboard-core-view />

    <dashboard-core-settings />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',
    created() {
      bus.$on('onProgressLinear', () => this.onProgress = true)
        .$on('offProgressLinear', () => this.onProgress = false)
    },
    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
      ModalAgree: () =>  import('./component/ModalAgree.vue'),
    },

    data: () => ({
      expandOnHover: false,
      onProgress : false
    }),
  }
</script>
